import { Box, Grid, Link, Typography } from '@mui/material';
import Image from 'next/image';

// import moment from 'moment';
// import { useState } from 'react';

const BlogContent = () => {
  // const router = useRouter();
  // const [blogItems, setBolgItems] = useState<any[]>([]);
  // async function fetchData() {
  //   await fetch(
  //     'https://api.rss2json.com/v1/api.json?rss_url=https://blog.taxzerone.com/feed/'
  //   )
  //     .then(async (result: any) => {
  //       const data = await result.json();
  //       const { items } = data;
  //       let temp = 0;
  //       const list: any[] = [];
  //       items.forEach((row: any) => {
  //         if (temp < 3) {
  //           list.push({
  //             link: row.link.replace(
  //               'https://blogtaxzerone.wpcomstaging.com/',
  //               'https://blog.taxzerone.com/posts/'
  //             ),
  //             imglink: row.link.replace(
  //               'https://blogtaxzerone.wpcomstaging.com/',
  //               'https://blogtaxzerone.wpcomstaging.com/wp-content/uploads/'
  //             ),
  //             title: row.title,
  //             content: row.description,
  //             date: moment(row.pubDate).format('MMM DD, YYYY'),
  //             image: row.imglink,
  //           });
  //           temp += 1;
  //         }
  //       });
  //       //  setBolgItems(list);
  //     })
  //     .catch((error) => {
  //       // eslint-disable-next-line no-console
  //       console.error(error);
  //     });
  // }

  // useEffect(() => {
  //   if (router.isReady) {
  //     fetchData();
  //   }
  // }, [router.isReady]);

  return (
    <>
      {/* {blogItems.map((item: any, index) => (
        <Grid
          item
          xs={12}
          md={4}
          sm={4}
          key={index}
          
          textAlign="left"
        >
          <Box
            sx={{
              border: '1px solid #eaeaea',
              p: 1.5,
              backgroundColor: '#fff',
              pb: { xs: 2, sm: 2 },
              borderRadius: 3,
              minHeight: '100%',
            }}
          >
            <Link
              href={item.link}
              target={'_blank'}
              rel="noreferrer"
              sx={{
                color: '#333',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              <Box
                sx={{
                  borderRadius: 2,
                  overflow: 'hidden',
                  position: 'relative',
                  mb: 2,
                  '& img': {
                    transform: 'scale(1)',
                    transition: 'all .3s ease',
                    //  objectFit: 'cover',
                    width: '100%',
                    height: 'auto',
                  },
                  '& img:hover': { transform: 'scale(1.11)' },
                }}
              >
                <img
                  src={`${item.imglink}.png`}
                  alt={item.title}
                  width={394}
                  height={251}
                />
              </Box>

              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: 16, md: 16 },
                  mb: { xs: 1, sm: 1 },
                  fontWeight: 600,
                  minHeight: { xs: 1, sm: 35 },
                }}
              >
                {item.title}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  maxHeight: 'none',
                  overflow: 'hidden',
                  display: '-webkit-box',
                  wordBreak: 'break-word',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  mt: 1,
                }}
              >
                <small
                  style={{
                    fontWeight: 500,
                    fontStyle: 'italic',
                    color: '#7b7b7b',
                  }}
                >
                  {item.date}
                </small>
                <br />
                {item.content}
              </Typography>
            </Link>
          </Box>
        </Grid>
      ))} */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Grid container spacing={2} alignItems="stretch">
          {/* Card 1 */}
          <Grid
            size={{ xs: 12, sm: 4 }}
            sx={{ display: 'flex' }}
            textAlign="left"
          >
            <Box
              sx={{
                border: '1px solid #eaeaea',
                p: 1.5,
                backgroundColor: '#fff',
                borderRadius: 3,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Link
                href="https://blog.taxzerone.com/posts/taxzerone-now-accepts-form-941-q3-filings-for-2026-heres-what-employers-need-to-know/"
                target="_blank"
                sx={{
                  color: '#333',
                  textDecoration: 'none',
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                <Box
                  sx={{
                    overflow: 'hidden',
                    border: '5px solid #42453f',
                    borderRadius: 2.5,
                    mb: 2,
                    width: '100%',
                    lineHeight: 0,
                    '& img': {
                      width: '100%',
                      height: 'auto',
                      display: 'block',
                      transition: 'transform 0.3s ease',
                    },
                    '&:hover img': {
                      transform: 'scale(1.08)',
                    },
                  }}
                >
                  <Image
                    src="https://blog.taxzerone.com/wp-content/uploads/form-941-quater-3.jpg"
                    alt="TaxZerone Now Accepts Form 941 Q3 Filings for 2026"
                    width={394}
                    height={247}
                    sizes="(max-width: 600px) 100vw, (max-width: 900px) 33vw, 394px"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: 16, md: 16 },
                    fontWeight: 600,
                    mb: 1,
                    lineHeight: 1.35,
                    height: { sm: 44 },
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  TaxZerone Now Accepts Form 941 Q3 Filings for 2026: Here’s
                  What Employers Need to Know
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: 'Poppins',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    wordBreak: 'break-word',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    mt: 1,
                  }}
                >
                  <small
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 500,
                      fontStyle: 'italic',
                    }}
                  >
                    September 21, 2026
                  </small>
                  <br />
                  As the Form 941 Q3 of 2026 filing period approaches,
                  businesses across the U.S. are preparing their payroll records
                  to report quarterly employment taxes.
                </Typography>
              </Link>
            </Box>
          </Grid>

          {/* Card 2 */}
          <Grid
            size={{ xs: 12, sm: 4 }}
            sx={{ display: 'flex' }}
            textAlign="left"
          >
            <Box
              sx={{
                border: '1px solid #eaeaea',
                p: 1.5,
                backgroundColor: '#fff',
                borderRadius: 3,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Link
                href="https://blog.taxzerone.com/posts/whats-new-in-form-941-for-2026-key-changes-explained/"
                target="_blank"
                sx={{
                  color: '#333',
                  textDecoration: 'none',
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                <Box
                  sx={{
                    overflow: 'hidden',
                    border: '5px solid #42453f',
                    borderRadius: 2.5,
                    mb: 2,
                    width: '100%',
                    lineHeight: 0,
                    '& img': {
                      width: '100%',
                      height: 'auto',
                      display: 'block',
                      transition: 'transform 0.3s ease',
                    },
                    '&:hover img': {
                      transform: 'scale(1.08)',
                    },
                  }}
                >
                  <Image
                    src="https://blog.taxzerone.com/wp-content/uploads/form-941-for-2026-3.png"
                    alt="What’s New in Form 941 for 2026 – Key Changes Explained"
                    width={394}
                    height={247}
                    sizes="(max-width: 600px) 100vw, (max-width: 900px) 33vw, 394px"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: 16, md: 16 },
                    fontWeight: 600,
                    mb: 1,
                    lineHeight: 1.35,
                    height: { sm: 44 },
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  What’s New in Form 941 for 2026 – Key Changes Explained
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: 'Poppins',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    wordBreak: 'break-word',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    mt: 1,
                  }}
                >
                  <small
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 500,
                      fontStyle: 'italic',
                    }}
                  >
                    March 10, 2026
                  </small>
                  <br />
                  The IRS has made a few general updates for the 2026 tax year
                  to improve payroll reporting and refund processing.
                </Typography>
              </Link>
            </Box>
          </Grid>

          {/* Card 3 */}
          <Grid
            size={{ xs: 12, sm: 4 }}
            sx={{ display: 'flex' }}
            textAlign="left"
          >
            <Box
              sx={{
                border: '1px solid #eaeaea',
                p: 1.5,
                backgroundColor: '#fff',
                borderRadius: 3,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Link
                href="https://blog.taxzerone.com/posts/september-15-2026-tax-deadline-what-form-1120-s-form-1065-filers-need-to-know/"
                target="_blank"
                sx={{
                  color: '#333',
                  textDecoration: 'none',
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                <Box
                  sx={{
                    overflow: 'hidden',
                    border: '5px solid #42453f',
                    borderRadius: 2.5,
                    mb: 2,
                    width: '100%',
                    lineHeight: 0,
                    '& img': {
                      width: '100%',
                      height: 'auto',
                      display: 'block',
                      transition: 'transform 0.3s ease',
                    },
                    '&:hover img': {
                      transform: 'scale(1.08)',
                    },
                  }}
                >
                  <Image
                    src="https://blog.taxzerone.com/wp-content/uploads/business-tax-forms-3.png"
                    alt="September 15, 2026 Tax Deadline: What Form 1120-S & Form 1065 Filers Need to Know"
                    width={394}
                    height={247}
                    sizes="(max-width: 600px) 100vw, (max-width: 900px) 33vw, 394px"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: 16, md: 16 },
                    fontWeight: 600,
                    mb: 1,
                    lineHeight: 1.35,
                    height: { sm: 44 },
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  September 15, 2026 Tax Deadline: What Form 1120-S & Form 1065
                  Filers Need to Know
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: 'Poppins',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    wordBreak: 'break-word',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    mt: 1,
                  }}
                >
                  <small
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 500,
                      fontStyle: 'italic',
                    }}
                  >
                    September 8, 2026
                  </small>
                  <br />
                  Filed Form 7004 to request an extension for your business tax
                  return? Eligible calendar-year S corporations and partnerships
                  generally have until September 15, 2026.
                </Typography>
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default BlogContent;
